$(document).ready(function(){
  AOS.init({
    duration: 1200,
  });
  
  $('.btn__downloads').on('click',function(e){
    e.preventDefault();
    $('.download_btn').trigger('click');
  });

  $('.home_banner_slider').owlCarousel({
    items: 1,
    loop: false,
    dots:true,
    nav:true,
    navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>']
  });

  $('.annou_text_slider').slick({
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 2000
  });
  
  $(".footer_logo_slider").owlCarousel({
    rewind: true,
    margin: 0,
    responsiveClass: true,
    dots:false,
    nav:true,
    navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
    responsive: {
      0:{items: 2},
      500:{items: 3},
      768:{items: 4},
      1024:{items: 5},
      1366:{items: 6}
    }
  });

  $('.home_second_announce_block').owlCarousel({
    items: 1,
    loop: true,
    dots:false,
    nav:false,
    navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
    responsiveClass:true,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    responsive: {
      0:{items: 1},
      768:{items: 1}
    }
  });
  
  $('.home_populair_tab1 .home_populair_tab_wrap,.home_populair_tab2 .home_populair_tab_wrap').each(function(){
    var val = $(this).find('.home_populair_slider .owl-item').length;
    if(val < 5){
      $(this).find('.home_populair_slider .owl-nav').hide();
    }
  });

  $('.home_populair_tab1 .home_populair_tab_wrap').first().addClass('active');
  $('.home_populair_tab2 .home_populair_tab_wrap').first().addClass('active');
  $('.home_populair_tab1 .home_populair_tab_head li').first().addClass('active');
  $('.home_populair_tab2 .home_populair_tab_head li').first().addClass('active');

  $('.home_populair_tab1 li h4').on('click',function(){
    $(this).parent('li').addClass('active');
    $(this).parent('li').siblings().removeClass('active');
    var title = $(this).attr('data-id');
    $('.home_populair_tab1 .home_populair_tab_wrap').each(function(){
      var val = $(this).find('.home_populair_slider .owl-item').length;
      if(val < 5){
        $(this).find('.home_populair_slider .owl-nav').hide();
      }
      var tab = $(this).attr('data-id');
      if(tab == title){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
      }
    });
  });
  

  $('.home_populair_tab2 li h4').on('click',function(){
    $(this).parent('li').addClass('active');
    $(this).parent('li').siblings().removeClass('active');
    var title = $(this).attr('data-id');
    $('.home_populair_tab2 .home_populair_tab_wrap').each(function(){
      var val = $(this).find('.home_populair_slider .owl-item').length;
      if(val < 5){
        $(this).find('.home_populair_slider .owl-nav').hide();
      }
      var tab = $(this).attr('data-id');
      if(tab == title){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
      }
    });
  });
  
  $(".home_populair_slider").owlCarousel({
    rewind: true,
    margin: 0,
    responsiveClass: true,
    dots:false,
    nav:true,
    navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
    responsive: {
      0: {items: 2,dots:true},
      650: {items: 3},
      924: {items: 4}
    }
  });
  
  $('.retour_dagen_tab_head h4').on('click',function(){
    $(this).toggleClass('active');
    $(this).parents('.retour_dagen_tab li').siblings().find('.retour_dagen_tab_head h4').removeClass('active');
    $(this).parent('.retour_dagen_tab_head').next('.retour_dagen_tab_content').slideToggle();
    $(this).parents('.retour_dagen_tab li').siblings().find('.retour_dagen_tab_content').slideUp();
  });

//   $('.faqs_content ul').each(function(){
//     $(this).find('li:first .faqs_ans').slideDown()
//   });
  $('.faqs_que h4').on('click',function(){
    $(this).toggleClass('active');
    $(this).parents('.faqs_content li').siblings().find('.faqs_que h4').removeClass('active');
    $(this).parent('.faqs_que').next('.faqs_ans').slideToggle();
    $(this).parents('.faqs_content li').siblings().find('.faqs_ans').slideUp();
  });

  $('.skin_inner_grid_wrap figure,.product_content,.product_img_block img,.footer_section h2').matchHeight({});
  
  var contantValue = 0;
  function recursive() {
    if ($('.collection_product .product_img_block img,.product_recommendation_slider .product_content,.product_recommendation_slider .product_img_block img,.home_populair_tab_wrap .product_img_block img').length){
      $('.collection_product .product_img_block img,.product_recommendation_slider .product_img_block img,.home_populair_tab_wrap .product_img_block img').matchHeight({});
      $('.product_recommendation_slider .product_content').matchHeight({})
    }
    else{
      contantValue++;
      setTimeout(function(){ recursive(); }, 1000);
    }
  }
  recursive();
  
//   var reviewVal = 0;
//   function review(){
//     if($('.product_content .wc_review_badge_inner').length){
//       $('.home_favorite_content .product_content').matchHeight({})
//     }else{
//       reviewVal++;
//       setTimeout(function(){ review(); }, 1000);
//     }
//   }
//   review();

  $('.contact_form_desc a').on('click',function(e){
    e.preventDefault();
    $('body').addClass('contact_active');
    $('.globo-form-app label').matchHeight({});
  });
  
  $('.contact_popup_overly,.contact_popup_close').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('contact_active');
  });
  
  $('.product_tab_head li').first().addClass('active');
  $('.product_tab_desc li').first().addClass('active');
  $('.product_tab_head h2').on('click',function(e){
    e.preventDefault();
    $(this).parent('li').addClass('active');
    $(this).parent('li').siblings().removeClass('active');
    var title = $(this).find('a').attr('href');
    $('.product_tab_desc li').each(function(){
      var desc = $(this).find('a').attr('href');
      if(title == desc){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
      }
    });
  });
  
  //   cart drawer
  $(".head_addtocart").on('click',function(e){
    e.preventDefault();
    $("body").addClass("CartOpen");
    $("body").removeClass("active_menu");
    $('.mobile_menu_btn').removeClass('active');
  });
  $(".cart_overly,.cartClose").on('click',function(e){
    e.preventDefault();
    $(".cart_item").hide();
    $("body").removeClass("CartOpen");
  });
  
  $('.cart_page_dispatch_block a').on('click',function(e){
    e.preventDefault();
    $(this).next('#shipping-calculator').slideToggle();
  });
//   mobile menu drawer
  $('.mobile_menu_btn').on('click',function(e){
    e.preventDefault();
    if($(window).width() > 767){
      if($('.header_section').hasClass('sticky_header')){
        var header = $('.header_section').innerHeight();
      }else{
        var header = $('.announcement_bar').innerHeight() + $('.header_section').innerHeight();
      }
    }else{
      var header = $('.header_section').innerHeight();
    }
    $('.mobile_popup').css('top',header+'px');
    $('body').removeClass('coll_filter_active');
    $(this).toggleClass('active');
    if($('.mobile_menu_btn').hasClass('active')){
      $('body').addClass('active_menu');
    }else{
      $('body').removeClass('active_menu');
    }
  });
  $('.mobile_overly').on('click',function(){
    $('body').removeClass('active_menu');
    $('.mobile_menu_btn').removeClass('active');
  });  

  $('.mb_megamenu_arrow').on('click',function(){
    $(this).parents('.mb_megamenu_link').toggleClass('active');
    $(this).parents('.mb_megamenu_link').next('.mb_childMenu').slideToggle();
  });
  
//   login / register drawer
  $('.head_login_btn').on('click',function(e){
    e.preventDefault();
    $('body').addClass('active_login');
    $('body').removeClass('active_menu');
    $('.mobile_menu_btn').removeClass('active');
    $('.login_popup_wrap').html($('#login_form').html());
    
    
  });
  $('.login_popup_close,.login_overly').on('click',function(){
    $('body').removeClass('active_login');
  });
  $(document).keydown(function(e){
    if(e.keyCode == 27){
      $('body').removeClass('active_login CartOpen active_menu');
      $('.mobile_menu_btn').removeClass('active');
    }
  });

  //   click_to_scroll
  $('.click_to_scroll').on('click',function(e){
    e.preventDefault();
    $('html,body').animate({scrollTop: $($(this).attr('href')).offset().top},'5000');
  });
  
  //   header search box
  $('.header_search').on('click',function(){
    $('.head_search_box').show();
    $('.head_icon_blocks').hide();
  });
  $(document).on('click', 'body', function(e){
    var tag = $('.head_search_box,.header_search');
    if (!tag.is(e.target) && tag.has(e.target).length === 0) {
      $('.head_search_box').hide();
      $('.head_icon_blocks').show();
    }
  });
  
//   collection filter sidebar
  $('.coll_filter_btn a').on('click',function(e){
    e.preventDefault();
    $('.coll_filter_sidebar').addClass('active');
    $('body').toggleClass('coll_filter_active');
    var width = $('#main-collection-product-grid li').innerWidth();
    $('.coll_filter_sidebar').css('width',width);
    if($(window).width() < 768){
      $('.boost-pfs-filter-toolbar-top-mobile button').trigger('click');
    }
  });
  
  $('.coll_filter_close').on('click',function(e){
    e.preventDefault();
    $('.coll_filter_sidebar').removeClass('active');
    $('.coll_filter_btn a').trigger('click');
  });
  
  $('.footer_section h2').on('click',function(){
    var width = $(window).width();
    if(width < 576){
      $(this).toggleClass('active');
      $(this).parents('.footer_menu').find('ul').slideToggle();
    }
  });
  
  $('.product_tab_desc li').first().find('.pro_mb_tab_desc').slideDown();
  $('.pro_mb_tab_title').first().addClass('active');
  $('.pro_mb_tab_title').on('click',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parents('.product_tab_desc li').siblings().find('.pro_mb_tab_title').removeClass('active');
    $(this).next('.pro_mb_tab_desc').slideToggle();
    $(this).parents('.product_tab_desc li').siblings('li').find('.pro_mb_tab_desc').slideUp();
  });
  
  if($('.wc--template--product').length){
    if($(window).width() <= 575){			   
      $(window).scroll(function() {
        var windowpos = $(window).scrollTop();
        if (windowpos >= $(".product-form__buttons").position().top & windowpos <=1000) {
          $('.mb_cart_btn').hide();
        } else {
          $('.mb_cart_btn').show();
        }
      });
    }
  }

  if($('.skin_inner_block').length){
    if($(window).width() <= 575){			   
      $(window).scroll(function() {
        var pos = $(window).scrollTop();
        var docViewBottom = pos + $(window).height();
        var elemTop = $('.skin_inner_form_slider').offset().top;
        if(elemTop < docViewBottom){
          $('.skin_inner_form_content').removeClass('sticky');
        } else {
          $('.skin_inner_form_content').addClass('sticky');
        }
      });
    }
  }
  
  $(".skin_inner_form_mb_content").on("click" , function(e){ 
    e.preventDefault();
    $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 1000, 'linear');
  });

});

$(window).on('load',function(){
  var cd_height = $('.cart_drawer_head').innerHeight() + $('.cart_drawer_footer').innerHeight();
  $('.productInCart').css('height', $(window).height() - cd_height + 'px');
});
$(window).resize(function(){
  var cd_height = $('.cart_drawer_head').innerHeight() + $('.cart_drawer_footer').innerHeight();
  $('.productInCart').css('height', $(window).height() - cd_height + 'px');
});

/*------------ Cart Height ---------------*/
function myCartSection() {
  var height = $('.block-cart-header').innerHeight() + $('.cart_drawer_footer').innerHeight();
  $('.cart_drawer_item').css('height', $(window).height() - height + 'px');
}
function mb_menu(){
  var width = $(window).width();
  if(width > 767){
    if($('.header_section').hasClass('sticky_header')){
      var header = $('.header_section').innerHeight();
    }else{
      var header = $('.announcement_bar').innerHeight() + $('.header_section').innerHeight();
    }
  }else{
    var header = $('.header_section').innerHeight();
  }
  $('.mobile_popup').css('top',header+'px');
}
$(window).on('load',function(){
  myCartSection();
  mb_menu();
});
$(window).resize(function(){
  myCartSection();
  mb_menu();
});
$( window ).scroll(function() {
  mb_menu();
});
/*------------ end Cart Height ---------------*/
function header_sticky(){
  var scroll = $(window).scrollTop();
  var header = $('.header_section.sticky_header').innerHeight() + $('.coll_topbar.coll_fixed').innerHeight();
  if (scroll >= 100) { 
    $('.header_section').addClass('sticky_header'); 
    $('.coll_topbar').addClass('coll_fixed');
    $('.coll_filter_sidebar').addClass('coll_sidebar_fixed');
    $('.coll_filter_sidebar.coll_sidebar_fixed').css('top',header+'px');
  }else { 
    $('.header_section').removeClass('sticky_header');
    $('.coll_topbar').removeClass('coll_fixed');
    $('.coll_filter_sidebar').removeClass('coll_sidebar_fixed');
  }
}
$(window).scroll(function() {
  header_sticky();
  var header = $('.header_section').innerHeight();
  $('.coll_topbar.coll_fixed').css('top',header+'px');
});

$(window).scroll(function(){
  
  
//   var docViewTop = $(window).scrollTop();
//   var docViewBottom = docViewTop + $(window).height();
//   var elemTop = $('.footer_section').offset().top;
  
//   var top = $('.header_section').innerHeight() + $('.coll_topbar.coll_fixed').innerHeight();
//   var width = $('#main-collection-product-grid li').innerWidth();
//   var left = ($(window).innerWidth() - $('.collection_product').innerWidth()) / 2;
//   var bottom = $('.footer_section').innerHeight();
  
//   console.log('docViewTop',docViewTop,'docViewBottom',docViewBottom,'elemTop',elemTop);
//   if(elemTop){
//     $('.coll_filter_sidebar.coll_sidebar_fixed').css({'top':'unset','bottom':bottom+'px','left':left+'px','width':width+'px'});
//   }else{
//     if ($(this).scrollTop() > 50) {
//       $('.coll_filter_sidebar.coll_sidebar_fixed').css({'top':top+'px','left':left+'px','width':width+'px'});
//     } else {
//       $('.coll_filter_sidebar').css({'top':'0','left':'0'});
//     }
//   }
  

  var top = $('.header_section').innerHeight() + $('.coll_topbar.coll_fixed').innerHeight();
  var width = $('#main-collection-product-grid li').innerWidth();
  var left = ($(window).innerWidth() - $('.collection_product').innerWidth()) / 2;
  var bottom = $('.footer_section').innerHeight();
  var hT = $('.footer_section').offset().top,
      hH = $('.footer_section').outerHeight(),
      wH = $(window).height(),
      wS = $(this).scrollTop();
  var height = wH - (top + bottom);
  if (wS > (hT+hH-wH)){
    $('.coll_filter_sidebar.coll_sidebar_fixed').css({'top':'unset','height':height+'px','bottom':bottom+'px','left':left+'px','width':width+'px','padding-bottom':'0'});
  }else{
    if ($(this).scrollTop() > 50) {
      $('.coll_filter_sidebar.coll_sidebar_fixed').css({'top':top+'px','height':'100vh','left':left+'px','width':width+'px','bottom':'unset','padding-bottom':'300px'});
    } else {
      $('.coll_filter_sidebar').css({'top':'0','left':'0'});
    }
  }

  
  
//   var footer = $('.footer_section').offset().top;
//   console.log('footer',footer);

  
//   var top = $('.header_section').innerHeight() + $('.coll_topbar.coll_fixed').innerHeight();
//   var width = $('#main-collection-product-grid li').innerWidth();
//   var left = ($(window).innerWidth() - $('.collection_product').innerWidth()) / 2;
//   if ($(this).scrollTop() > 50) {
//     $('.coll_filter_sidebar.coll_sidebar_fixed').css({'top':top+'px','left':left+'px','width':width+'px'});
//   } else {
//     $('.coll_filter_sidebar').css({'top':'0','left':'0'});
//   }
});



$(document).ready(function(){
  header_sticky();
  
  var sync1 = $(".slider-for");
  var sync2 = $(".slider-nav");
  var slidesPerPage = 5; //globaly define number of elements per page
  var syncedSecondary = true;

 
  
  sync1.owlCarousel({
    items: 1,
    slideSpeed: 2000,
    nav: true,
    autoplay: false, 
    dots: true,
    loop: false,
    responsiveRefreshRate: 200,
     touchDrag  : false,
     mouseDrag  : false,
    navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
  }).on('changed.owl.carousel', syncPosition);

  sync2
  .on('initialized.owl.carousel', function() {
    sync2.find(".owl-item").eq(0).addClass("current");
  })
  .owlCarousel({
    items: slidesPerPage,
    dots: true,
    nav: true,
    smartSpeed: 200,
    slideSpeed: 500,
    slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
    responsiveRefreshRate: 100,
    navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    responsive: {
      0:{items: 4},
      1200:{items: 4}
    },
  }).on('changed.owl.carousel', syncPosition2);

  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;

    //if you disable loop you have to comment this block
    

    
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - (el.item.count / 2) - .5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    //end block

    sync2
    .find(".owl-item")
    .removeClass("current")
    .eq(current)
    .addClass("current");
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();

    if(current > end){
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if(current < start){
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }
    
   
  var activeslide =  $(sync1).find('.owl-item').eq(el.item.index);
    console.log();
    if(  $(activeslide).find('.3d_image').length > 0){
    $('.product_gallery').hide()
    }
    else{
    $('.product_gallery').show();
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }

  sync2.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    sync1.data('owl.carousel').to(number, 300, true);
  });
});


$(document).ready(function(){
  
  $(document).on('click','.quick_view',function(e){
    e.preventDefault();
    var handle = $(this).attr('data-handle');
    var id = $(this).attr('data-id');
    $("body").addClass('quickview_active');
    $(".quick_view_item").addClass('fadeInLeft');
      setTimeout(function() {
      $('.quick_view_item').removeClass('fadeInLeft');
    }, 1000);
  var parent = $(this).parents('li');
   var image = $(parent).find('.data_image').attr('data-image');
    var gift_products = $(parent).find('.gift_product').attr('data-image');
    var desc = $(parent).find('.short_description').html();
   

    function product_item(product,metafield){
    
      var gift_prodct_html = $('.quick_view_gift_pro').html();
      var format = $('#shop_currency_val').text();
      var product = product;
      var url = product.url;
      var title = product.title;
      var handle = product.handle;
      var id = product.id;
      var price = Shopify.formatMoney(product.price,format);
      var compare_price = Shopify.formatMoney(product.compare_at_price_min,format);
      var img = product.images;
      var variants = product.variants;
      var options = product.options;
      var tags = product.tags;
      var vendor = product.vendor;
      var mainHtml = '';
      
      

      mainHtml += '<div class="quick_view_block product__info-container" data-id="'+ product.variants[0].id +'">';
      mainHtml += '<div class="quick_view_overly"></div>';
      mainHtml += '<div class="quick_view_item">';
      mainHtml += '<div class="quick_view_head">';
      mainHtml += '<a href="#" class="quick_view_close"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 378.303 378.303" style="enable-background:new 0 0 378.303 378.303;" xml:space="preserve"><polygon style="fill:#000;" points="378.303,28.285 350.018,0 189.151,160.867 28.285,0 0,28.285 160.867,189.151 0,350.018   28.285,378.302 189.151,217.436 350.018,378.302 378.303,350.018 217.436,189.151 "/></svg></a>';
      mainHtml += '</div>';
      mainHtml += '<div class="row quick_view_row">';
      mainHtml += '<div class="col col-12 col-sm-12 col-md-6 quick_view_img_block">';
      mainHtml += '<div class="quick_view_wrap">';
      mainHtml += '<ul class="quick_view_img_slider owl-carousel">';
      $.each(img,function(index,value){
        mainHtml += '<li><figure><img src="'+ value +'" alt="" /></figure></li>';
      });
      mainHtml += '</ul>';
//       $.each(metafield[0],function(index,value){
//         $.each(value,function(i,val){
//           if(val.key == 'gift_product'){
            if(gift_products == 'true'){
              mainHtml += '<span class="gift_tag">+ GRATIS CADEAU</span>';
            }
//           }
//         });
//       });
      mainHtml += '<a href="'+ url +'" class="button view_detail_btn">View details</a>';
      mainHtml += '</div>';
      mainHtml += '</div>';
      mainHtml += '<div class="col col-12 col-sm-12 col-md-6 scroll_css quick_view_desc_block">';
      mainHtml += '<div class="quick_view_wrap quick_view_content">';
      mainHtml += '<h2>'+ title +'</h2>';
      mainHtml += '<div class="product_brand_img">';
//       $.each(metafield[0],function(index,value){
//         $.each(value,function(i,val){
          if(image != ''){
            mainHtml += '<a href="/collections/all?pf_v_merken='+ vendor +'"><img src="'+ val.value +'" alt="" /></a>';
          }
//         });
//       });
      mainHtml += '</div>';
      mainHtml += '<div class="wc_product_review_badge" data-handle="'+ handle +'" data-product_id="'+ id +'"></div>';
      mainHtml += '<div class="quick_view_price">';
      if(compare_price != '€0.00'){
        mainHtml += '<span class="p_compare_price">'+ compare_price +'</span>';
      }
      if(price != '€0.00'){
        mainHtml += '<span class="p_price">'+ price +'</span>';
      }
      mainHtml += '</div>';
      mainHtml += '<div class="quick_view_desc">';
//       $.each(metafield[0],function(index,value){
//         $.each(value,function(i,val){
          if(desc != ''){
            mainHtml += desc;
          }
//         });
//       });
      mainHtml += '</div>';
      
//       $.each(metafield[0],function(index,value){
//         $.each(value,function(i,val){
//           if(val.key == 'gift_product'){
            if(gift_products == 'true'){
              mainHtml += gift_prodct_html;
            }
//           }
//         });
//       });

      mainHtml += '<div class="quick_view_qty">';
      
      mainHtml += '<div class="product-form__input product-form__quantity cart-item__quantity">';
      mainHtml += '<quantity-input class="quantity">';
      mainHtml += '<button class="quantity__button no-js-hidden" name="minus" type="button">';
      mainHtml += '<span class="visually-hidden">Decrease quantity for '+ title +'</span>';
      mainHtml += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>';
      mainHtml += '</button>';
      mainHtml += '<input class="quantity__input" type="number" name="quantity" id="Quantity-template--14372611555465__main" min="1" value="1" form="product-form-template--14372611555465__main">';
      mainHtml += '<button class="quantity__button no-js-hidden" name="plus" type="button">';
      mainHtml += '<span class="visually-hidden">Increase quantity for '+ title +'</span>';
      mainHtml += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
      mainHtml += '</button>';
      mainHtml += '</quantity-input>';
      mainHtml += '</div>';
      
      mainHtml += '<div class="quick_view_add_cart">';
      mainHtml += '<a href="#" class="button">+ SNEL TOEVOEGEN</a>';
      mainHtml += '</div>';
      
      mainHtml += '</div>';

      mainHtml += '<div class="product_meta">';
      mainHtml += '<div class="product_meta_block">';
      mainHtml += '<span class="product_meta_title">Artikelnummer:</span>';
      mainHtml += '<span>';
      if(variants[0].sku != ''){
        mainHtml += variants[0].sku;
      }else{
        mainHtml += 'Niet beschikbaar';
      }
      mainHtml += '</span>';
      mainHtml += '</div>';
      
      var tag_arr = [];
      $.each(tags,function(index,value){
        if(value.includes("product_") == true){
          tag_arr.push(value.replace('product_',''));
        }
      });
      if(tag_arr != ''){
        mainHtml += '<div class="product_meta_block">';
        mainHtml += '<span class="product_meta_title">Tag:</span>';
        mainHtml += '<span>'+ tag_arr.join(',') +'</span>';
        mainHtml += '</div>';
      }
      
      mainHtml += '<div class="product_meta_block product_share">';
      mainHtml += '<span class="product_meta_title">Share:</span>';
      mainHtml += ' <span>';
      mainHtml += '<a target="_blank" href="//www.facebook.com/sharer.php?u='+ shopUrl + url +'"><i class="fab fa-facebook-f"></i></a>';
      mainHtml += '<a target="_blank" href="//api.whatsapp.com/send?text='+ shopUrl + url +'"><i class="fab fa-whatsapp"></i></a>';
      mainHtml += '</span>';
      mainHtml += '';
      mainHtml += '</div>';
      mainHtml += '</div>';

      mainHtml += '</div>';
      mainHtml += '</div>';
      mainHtml += '</div>';
      mainHtml += '</div>';
      mainHtml += '</div>';
      $('.quick_view_model').html(mainHtml);
       $('.gift_product_wrap').removeClass('active');
      $(".quick_view_img_slider").owlCarousel({
        rewind: true,
        margin: 0,
        responsiveClass: true,
        dots:false,
        nav:true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
        responsive: {
          0: {items: 1},
          576: {items: 1},
          1366: {items: 1}
        }
      });
    }

    var ajax1 = $.ajax({
      type: "GET",
      dataType: "json",
      url: "/products/"+ handle +".js",
      async: true,
      success: function(result) {
        return result;                                         
      }
    });

//     var ajax2 = $.ajax({
//       type: "GET",
//       dataType: "json",
//       url: "/admin/products/"+ id +"/metafields.json",
//       async: true,
//       success: function(result) {
//         return result;
//       }  
//     });
    

    $.when(ajax1).done(function(a,b) {
      product_item(a,b);
    });

    return false;
  });
});

$(document).on('click','.quick_view_add_cart a',function(e){
 
//   e.preventDefault();
//   var qty = $(this).parents('.quick_view_qty').find('.product-form__input .quantity__input').val();
//   var id= $('.product__info-container').attr('data-id');
//   var ajax = {
//     type: "POST",
//     url: "/cart/add.js",
//     data: "quantity=" + qty + "&id=" + id,
//     dataType: "json",
//     success: function(item){
//       if((typeof callback) === 'function'){
//         callback(item, id);
//       } else{
//         wc_theme_source.lib.on_item_added(item);
//       }
//       setTimeout(function(){
//         $('body').addClass('CartOpen');
//         $('.quick_view_item').addClass('fadeInRight');
//         setTimeout(function() {
//       $('.quick_view_item').removeClass('fadeInRight');
//      $('body').removeClass('quickview_active');
//     }, 500);
//       },500);
//     },
//     error: function(XMLHttpRequest, textStatus){
//       wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
//     }
//   };
//   jQuery.ajax(ajax);
  var parents = $(this).parents('.quick_view_content');
   e.preventDefault();
   
    if($(parents).find(".gift_enable_disable").prop('checked') == true){
      var normal_pro_id = $('.product__info-container').attr('data-id');
      var normal_pro_qty = $('.quick_view_qty .quantity__input').val();
      var normal_pro_prop = [];
      $('.bundle_product_block').each(function(){
        var title = $(this).attr('data-title');
        normal_pro_prop.push(title);
      });
      var items = [];
      $('.product_properties li').each(function(){
        var item = $(this).find('select').val();
        items.push(item);
      });

      var gift_pro_id = $('.gift_product_wrap').attr('data-id');
      var gift_fname = $('.gift_fname').val();
      var gift_lname = $('.gift_lname').val();
      var gift_msg = $('.gift_msg').val();
      if($(".gift_enable_disable").prop('checked') == true){
        var gift_pro_qty = 1;
      }else{
        var gift_pro_qty = 0;
      }

      var gift_card_name = $('.gift_card_name').val();
      var gift_card_msg = $('.gift_card_msg').val();

      var line_items = new Array();
      line_items = [
        {
          product_id: normal_pro_id,
          quantity: normal_pro_qty
        },
        {
          product_id: gift_pro_id,
          quantity: gift_pro_qty,
          propertie:{'First Name':gift_fname,'Last Name':gift_lname,'Gift Wrap Message':gift_msg}
        }
      ]
      function moveAlong(){
        if(line_items.length > 0){
        var request = line_items.shift();
        var tempId= request.product_id;
        var tempQty = request.quantity;
        var tempProperties = request.propertie;
        if(tempProperties != '' && tempProperties != undefined){
        var data = {quantity:tempQty, id:tempId,properties:tempProperties}
        }else{
        var data = {quantity:tempQty, id:tempId}
        }
        
        var params = {
          type: 'POST',
          url: '/cart/add.js',         
          data: data,         
          dataType: 'json',
          success: function(line_item){
            console.log('success');
            moveAlong();
          //  wc_theme_source.lib.addtocart_product(line_item.variant_id, line_item.quantity, '');
            return false;
          },
          error: function(){
            console.log('fail');
            moveAlong();
          }
        };
        $.ajax(params);
      }
        else{
           ajaxCart.load();
         setTimeout(function(){
              $('body').addClass('CartOpen');
              $('body').removeClass('quickview_active');
            },500);
        }
      }
      moveAlong();
    }
    else{
      var pro_id = $('.product__info-container').attr('data-id');
      var pro_qty = $('.quick_view_qty input').val();
      var normal_pro_prop = [];
      $('.bundle_product_block').each(function(){
        var title = $(this).attr('data-title');
        normal_pro_prop.push(title);
      });
      var items = [];
      $('.product_properties li').each(function(){
        var item = $(this).find('select').val().split('-').join(' ');
        items.push(item);
      });
      
      var gift_card_name = $('.gift_card_name').val();
      var gift_card_msg = $('.gift_card_msg').val();
     
      $.post('/cart/add.js', {
        items: [
          {
            quantity: pro_qty,
            id: pro_id
          }
        ]
      },function(data){
        if((typeof callback) === 'function'){
          callback(data, pro_id);
        } else{
          wc_theme_source.lib.on_item_added(data);
        }
        setTimeout(function(){
          $('body').addClass('CartOpen');
          $('.quick_view_item').addClass('fadeInRight');
          setTimeout(function() {
            $('.quick_view_item').removeClass('fadeInRight');
            $('body').removeClass('quickview_active');
          }, 500);
        },500);
      });
    }       
});

$(document).on('click','.quick_view_overly,.quick_view_close',function(e){
  e.preventDefault();
  $('.quick_view_item').addClass('fadeInRight');
 
  setTimeout(function() {
      $('.quick_view_item').removeClass('fadeInRight');
     $('body').removeClass('quickview_active');
    }, 500);
  $('.gift_product_wrap').removeClass('active');
});

// gift card
$(document).on('keyup','.gift_card_wrap textarea',function(val){
  var len = $(this).val().length;
  if (len <= 500){
    $('.gift_card_msg_count').text(500 - len);
  } 
});

//   gift product 
$(document).on('keyup','.gift_input_prop',function(val){
  var len = $(this).val().length;
  if (len <= 100){
    $('.gift_mess_count').text(100 - len);
  } 
});
$(document).on('change',".gift_enable_disable",function() {
  $('.gift_product_wrap').toggleClass('active');
});
//   end gift product

function owlInitialize() {
  if ($(window).width() < 1025) {
    $('.home_favorite_slider').owlCarousel({
      loop:false,
      nav: false,
      dots: true,        
      responsive:{
        0:{
          items:2,
        },
        650:{
          items:3,
        },
        924:{
          items:4,
        },
      }
    });
  }else{
    $('.home_favorite_slider').owlCarousel('destroy');
  }
//   $('.home_favorite_slider .product_content').matchHeight({});
}

function usp(){
  if($(window).width() <= 575){
    $('.skin_inner_form_slider ul').owlCarousel({
      items: 1,
      loop: true,
      dots:false,
      nav:false,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
      responsiveClass:true,
      autoplay: true,
      autoplayTimeout: 3000,
      smartSpeed: 800,
      responsive: {
        0:{items: 1},
        768:{items: 1}
      }
    });
  }
  if($(window).width() <= 991){
    $('.home_second_banner_slider').owlCarousel({
      items: 1,
      loop: true,
      dots:false,
      nav:false,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/></svg>'],
      responsiveClass:true,
      autoplay: true,
      autoplayTimeout: 3000,
      smartSpeed: 800,
      responsive: {
        0:{items: 1},
        768:{items: 1}
      }
    });
  }
}



$(document).ready(function() {
  owlInitialize();
  usp();
  
  const myInterval = setInterval(review, 1000);
  function review() {
    var review = $('.spr-summary-starrating a').text().split(' total reviews').join('');
    $('.product_review_count').text(review);
    if(review == ''){
      $('.product_review_count').text('0');
    }
    var val = $('.product_review_count').text();
    if(parseInt(review) == parseInt(val)){
      clearInterval(myInterval);
    }
  }
});
$(window).resize(function() {
  owlInitialize();
  usp();
});
$(window).on('load',function() {
  owlInitialize();
  usp();
});

$(document).on('click','.boost-pfs-filter-show-result',function(e){
  
  e.preventDefault();
  $('body').removeClass('coll_filter_active');
//   $('.coll_filter_sidebar').removeClass('active');
//   $('html').removeClass('boost-pfs-body-no-scroll');
//   $('.coll_filter_btn a').trigger('click');
});